import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import classnames from "classnames";

var _isBetween = function _isBetween(c, d, a) {
  return 0 >= (c - d) * (c - a);
};

export var HorizontalRange = function HorizontalRange(a) {
  var b = a.name,
      c = a.options,
      d = a.value,
      f = a.onChange,
      g = _objectWithoutProperties(a, ["name", "options", "value", "onChange"]),
      h = c[0].value,
      i = c[c.length - 1].value,
      e = _slicedToArray(d, 2),
      j = e[0],
      k = e[1],
      l = function l(a) {
    var b = d,
        c = _slicedToArray(d, 2),
        e = c[0],
        g = c[1],
        j = parseInt(a.target.value),
        k = _isBetween(j, e, g);

    if (k) b = [j];else if (1 === d.length) {
      b = j >= e ? [e, j] : [j, e];
    } else if (1 < d.length) {
      b = j <= e ? [j, g] : [e, j];
    }

    var l = b,
        m = _slicedToArray(l, 2),
        n = m[0],
        o = m[1];

    if (n === j && o === j) return null;
    var p = h === b[0] && i === b[1];
    p && (b = null), "function" == typeof f && f(b, a);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "any-".concat(b),
    checked: h === j && i === k,
    onChange: function checkAll() {
      "function" == typeof f && f(null);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "any-".concat(b),
    className: "checkall"
  }, "All")), c.map(function (a, e) {
    var f = a.value,
        g = "".concat(b, "-").concat(e + 1),
        h = e === c.length - 1,
        i = -1 < d.indexOf(f),
        j = 0 === d.indexOf(f),
        k = d.indexOf(f) === d.length - 1,
        m = 1 === d.length;
    return /*#__PURE__*/React.createElement("span", {
      className: classnames("checkbox", {
        min: j,
        max: m || k
      }),
      key: g
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: g,
      value: f,
      onChange: l,
      checked: i
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: g
    }, h ? "".concat(f, "+") : f));
  }));
};
export default HorizontalRange;